import React, { useState } from 'react';
import { Download, Github, Menu, X } from 'lucide-react';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <nav className="site-nav" aria-label="Primary navigation">
      <div className="site-nav__inner">
        <a href="/" className="site-brand" aria-label="WP-Autoplugin home">
          <span className="site-brand__mark" aria-hidden="true">
            <img src="/logo.svg" alt="" />
          </span>
          <span>WP-Autoplugin</span>
          <span className="site-brand__version">v2</span>
        </a>

        <div className={`site-nav__links ${mobileMenuOpen ? 'is-open' : ''}`}>
          <a href="/#workspace" onClick={closeMenu}>Workspace</a>
          <a href="/#workflow" onClick={closeMenu}>Workflow</a>
          <a href="/#safety" onClick={closeMenu}>Safety</a>
          <a href="/#models" onClick={closeMenu}>Models</a>
        </div>

        <div className="site-nav__actions">
          <a
            className="site-nav__github"
            href="https://github.com/WP-Autoplugin/wp-autoplugin"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Github size={15} /> GitHub
          </a>
          <a
            className="site-nav__download"
            href="https://github.com/WP-Autoplugin/wp-autoplugin/releases/latest"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Download size={15} /> Download
          </a>
        </div>

        <button
          className="site-nav__toggle"
          type="button"
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen((isOpen) => !isOpen)}
        >
          {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
